import { render, staticRenderFns } from "./SavePurchasePopup.view.vue?vue&type=template&id=7345d91e&"
import script from "./SavePurchasePopup.view.vue?vue&type=script&lang=js&"
export * from "./SavePurchasePopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7345d91e')) {
      api.createRecord('7345d91e', component.options)
    } else {
      api.reload('7345d91e', component.options)
    }
    module.hot.accept("./SavePurchasePopup.view.vue?vue&type=template&id=7345d91e&", function () {
      api.rerender('7345d91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/save/SavePurchasePopup.view.vue"
export default component.exports